/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import { CopyButton } from '../button/CopyButton';
import React from 'react';
import './CopyTextContainer.scss';

interface Props {
  text: string | undefined;
  className?: string;
}

export const CopyTextContainer = ({ text, className = '' }: Props) => {

  if (!text) {
    return null;
  }

  return <div className={`copy-text-container ${className}`}>
    <p>{text}</p>
    <CopyButton text={text} />
  </div>
}
